var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import styled from "styled-components";
import Text from "../../Text/Text";
import { useTheme } from "../../ThemeProvider/ThemeProvider";
var StyledNavBarGroupItem = styled.li(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  position: relative;\n  flex-direction: row;\n  gap: 1rem;\n  align-items: center;\n  cursor: pointer;\n  border-radius: 0.5rem;\n  padding: 0.4rem 0 0.4rem 1.75rem;\n  margin: 0 0.5rem;\n  color: ", ";\n  background-color: ", ";\n  &:hover {\n    background-color: ", ";\n  }\n  &:active {\n    background-color: ", ";\n  }\n  &:focus-visible {\n    outline: 1px solid ", ";\n  }\n  &:after {\n    content: \"\";\n    position: absolute;\n    height: 100%;\n    margin-left: 0.43rem;\n    border-left: 1px solid\n      ", ";\n    top: 0;\n    left: 0;\n  }\n"], ["\n  display: flex;\n  position: relative;\n  flex-direction: row;\n  gap: 1rem;\n  align-items: center;\n  cursor: pointer;\n  border-radius: 0.5rem;\n  padding: 0.4rem 0 0.4rem 1.75rem;\n  margin: 0 0.5rem;\n  color: ", ";\n  background-color: ", ";\n  &:hover {\n    background-color: ", ";\n  }\n  &:active {\n    background-color: ", ";\n  }\n  &:focus-visible {\n    outline: 1px solid ", ";\n  }\n  &:after {\n    content: \"\";\n    position: absolute;\n    height: 100%;\n    margin-left: 0.43rem;\n    border-left: 1px solid\n      ", ";\n    top: 0;\n    left: 0;\n  }\n"])), function (props) {
    return props.$selected
        ? props.$colorPalette.primary.accentScale[10]
        : props.$colorPalette.primary.grayScale[11];
}, function (props) {
    return props.$selected
        ? props.$colorPalette.primary.accentScale[2]
        : "transparent";
}, function (props) {
    return props.$selected
        ? props.$colorPalette.primary.accentScale[3]
        : props.$colorPalette.primary.grayScale[1];
}, function (props) {
    return props.$selected
        ? props.$colorPalette.primary.accentScale[4]
        : props.$colorPalette.primary.grayScale[2];
}, function (props) { return props.$colorPalette.primary.accentScale[5]; }, function (props) { return props.$selected
    ? props.$colorPalette.primary.accentScale[5] : props.$colorPalette.primary.grayScale[5]; });
var StyledNavBarGrpItemIcon = styled.span(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  margin-left: auto;\n"], ["\n  margin-left: auto;\n"])));
var NavigationBarGroupItem = function (_a) {
    var _index = _a._index, value = _a.value, children = _a.children, leadingIcon = _a.leadingIcon, trailingIcon = _a.trailingIcon, className = _a.className, style = _a.style, size = _a.size, selected = _a.selected, _b = _a.tabIndex, tabIndex = _b === void 0 ? 0 : _b, 
    // Events
    _getSelectedIndex = _a._getSelectedIndex, onClick = _a.onClick;
    var colorPalette = useTheme().theme.colorPalette;
    var _c = React.useState(selected), _selected = _c[0], setSelected = _c[1];
    React.useEffect(function () {
        setSelected(selected);
    }, [selected]);
    var _onClick = function (e) {
        setSelected(true);
        _getSelectedIndex && _getSelectedIndex(_index, value);
        onClick && onClick(e);
    };
    var _handleKeyDown = function (e) {
        if (e.key === "Enter" || e.key === " ") {
            _onClick(e);
        }
    };
    return (_jsxs(StyledNavBarGroupItem, __assign({ tabIndex: tabIndex, "$selected": _selected, "$colorPalette": colorPalette, className: className, style: style, onClick: _onClick, onKeyDown: _handleKeyDown }, { children: [leadingIcon && (_jsx(StyledNavBarGrpItemIcon, { children: leadingIcon })), typeof children === "string" ? (_jsx(Text, __assign({ noColor: true, variant: "span", size: size }, { children: children }))) : (children), trailingIcon && (_jsx(StyledNavBarGrpItemIcon, { children: trailingIcon }))] })));
};
export default NavigationBarGroupItem;
var templateObject_1, templateObject_2;
